import Footer from "../Homepages/Footer";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import videoImages from "../Homepages/homeConfig";

export default function Videos() {
  const navigate = useNavigate();
  const { video1, video2, video3, video4, video5 } = videoImages.videoImages;
  return (
    <div className="container px-4 mb-5">
      <div className="heading mb-3 mt-4">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/video");
          }}
        />
        <h3 className="text-center no-wrap">Happiness Island</h3>
      </div>
      <h1 style={{ fontWeight: "bolder", fontSize: "35px" }} className="my-4">
        Watch Exciting context to brigthen your day
      </h1>
      <div className="container mb-5 d-flex flex-column">
        <div className="card mt-2 mb-4">
          <img className="card-img-top" src={video1} alt="Card" />
          <div className="card-body">
            <h5 className="card-title text-dark">
              This video is funny. This video is funny. This video is funny.
              This video is funny
            </h5>
            <p className="card-text">
              <small className="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div className="card mt-2 mb-4">
          <img className="card-img-top" src={video2} alt="Card" />
          <div className="card-body">
            <h5 className="card-title text-dark">
              This video is funny. This video is funny. This video is funny.
              This video is funny
            </h5>
            <p className="card-text">
              <small className="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div className="card mt-2 mb-4">
          <img className="card-img-top" src={video3} alt="Card" />
          <div className="card-body">
            <h5 className="card-title text-dark">
              This video is funny. This video is funny. This video is funny.
              This video is funny
            </h5>
            <p className="card-text">
              <small className="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div className="card mt-2 mb-4">
          <img className="card-img-top" src={video4} alt="Card" />
          <div className="card-body">
            <h5 className="card-title text-dark">
              This video is funny. This video is funny. This video is funny.
              This video is funny
            </h5>
            <p className="card-text">
              <small className="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div className="card mt-2 mb-4">
          <img className="card-img-top" src={video5} alt="Card" />
          <div className="card-body">
            <h5 className="card-title text-dark">
              This video is funny. This video is funny. This video is funny.
              This video is funny
            </h5>
            <p className="card-text">
              <small className="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
